module.exports = __webpack_public_path__ + "media/scene_1.c79705be.mp3";